import { TIME_ZONES } from "../../constants"

export const GET_TIME_ZONE_LABEL = (timeZoneValue: string) => {
    let timeZoneLabel: string = null;
    for(let zone of TIME_ZONES) {
        if(zone.value === timeZoneValue) {
            timeZoneLabel = zone.label;
            break;
        }
    }
    return timeZoneLabel;
}
